import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { EventTypes } from 'src/app/core/constants/event-types';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';
import { CommonModule } from '@angular/common';
import { BaseIndexModule } from 'src/app/pages/shared/base/modules/base-index.module';
import { ModalTitleComponent } from "../../../../shared/global/modal-title/modal-title.component";
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';


@Component({
    selector: 'delete-contacts-form-phonebooks.component',
    templateUrl: './delete-contacts-form-phonebooks.component.html',
    styles: [
        `
      // app-modal-title{
      //  min-width: 1280px !important;
      // }
      .mat-mdc-dialog-content {
        padding: 20px 30px !important;
      }
    `,
    ],
    imports: [BaseFormModule, ModalTitleComponent]
})
export class DeleteContactsFromPhonebooksComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  phonebooks?: number[] = [];
  currentPhonebookId: number;
  contactId: number;

  //#endregion

  constructor(
    private dialogRef: MatDialogRef<DeleteContactsFromPhonebooksComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
    if (data?.currentPhonebookId)
      this.currentPhonebookId = data?.currentPhonebookId;
    this.contactId = data?.contactId;
  }

  ngOnInit() {
    super.ngOnInit();
  }

  initForm() {
    this.form = new FormGroup({});
  }

  onSubmit() {
    this.unSubs();
    this.dialogRef.close(this.phonebooks);
  }

  onClose() {
    this.unSubs();
    this.dialogRef.close(false);
  }

  onSelectCurrentGroup() {
    try {
      let phonebook = this.phonebooks.find((phonebookId) => {
        return phonebookId === this.currentPhonebookId;
      });

      if (phonebook) return;

      this.phonebooks = [];
      this.phonebooks.push(this.currentPhonebookId);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  log(event) {}
}
